import { render, staticRenderFns } from "./RegistrationModal.vue?vue&type=template&id=54863f4e&"
import script from "./RegistrationModal.vue?vue&type=script&lang=js&"
export * from "./RegistrationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports